import { useForm } from "react-hook-form";
import { useCreateBodyMapEntryMutation } from "../../../services/api/bodyMapApi";
import { useDisplayToast } from "ui/hooks/useDisplayToast";
import { useResidentContext } from "../../residents/provider/ResidentProvider";
import { BodyMapEntryModel } from "../../../services/api/types/bodyMap/models/BodyMapEntryModel";

interface Props {
  selectedBodyParts: string[];
  onSuccess: (entry: BodyMapEntryModel) => Promise<void>;
}

export function useCreateBodyMapEntry({ selectedBodyParts, onSuccess }: Props) {
  const { residentId } = useResidentContext();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      locations: [],
      condition: "",
      initial_comment: "",
      treatment_plan: "",
      task_frequency: "",
    },
  });

  const [triggerCreateBodyMapEntry] = useCreateBodyMapEntryMutation();

  const { showNewToast, showErrorToast } = useDisplayToast();

  const submit = handleSubmit(async (data) => {
    try {
      if (!residentId) {
        return;
      }
      const transformedData = {
        ...data,
        locations: selectedBodyParts,
      };
      const newEntry = await triggerCreateBodyMapEntry({
        residentId,
        body: transformedData,
      }).unwrap();

      showNewToast({
        title: "Body entry logged successfully",
        message: "The entry has been created successfully",
        type: "success",
      });
      if (onSuccess) await onSuccess(newEntry);
    } catch (error) {
      showErrorToast(error);
    }
  });

  return { control, submit, isSubmitting };
}
